import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import pl from "./pl.json";
import en from "./en.json";

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      pl: { translation: pl },
      en: { translation: en },
    },
    fallbackLng: "pl",
    supportedLngs: ["pl", "en"],
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator", "htmlTag"],
      lookupLocalStorage: "oceannova-lang",
      caches: ["localStorage"],
    },
  });

// Keep <html lang> in sync
if (typeof document !== "undefined") {
  document.documentElement.lang = i18n.language?.startsWith("en") ? "en" : "pl";
  i18n.on("languageChanged", (lng) => {
    document.documentElement.lang = lng?.startsWith("en") ? "en" : "pl";
  });
}

export default i18n;
